import { vuexfireMutations } from 'vuexfire'
// import * as Sentry from '@sentry/browser'

export default {
  ...vuexfireMutations,

  notify (state, message) {
    state.alert = { message }
  },
  notifyError (state, { message, error }) {
    if (process.env.NODE_ENV === 'production') {
      // Sentry.captureException(error)
    } else {
      console.warn(error)
    }
    state.alert = { message, error: true }
  },
  setAppLoading (state, payload) {
    state.loading = !!payload
  },
  showUpdateBanner (state, show = true) {
    state.showUpdateBanner = show
  }
}
